import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from '@xstyled/styled-components';
import { styleVariables } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
export var EmptyAnswerLabel = styled.label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n  font-style: italic;\n"])), styleVariables.font.fontSizeSmall, styleVariables.font.fontWeightNormal, function (props) {
  return props.theme.color.textSupport;
});
export var AnswerItem = function AnswerItem(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    children: children
  });
};